// import React, { useEffect, useRef, useState } from "react";
// import {
//   Grid,
//   makeStyles,
//   Card,
//   CardContent,
//   Button,
//   CardHeader,
//   Select,
//   MenuItem,
//   Typography,
//   ThemeProvider,
//   createTheme,
//   Box,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   CircularProgress,
//   DialogActions,
// } from "@material-ui/core";
// import { Formik, Form, Field } from "formik";
// import * as Yup from "yup";
// import { TextField } from "formik-material-ui";
// import Receipt from "./receipt";
// import { Link, useParams } from "react-router-dom";
// import RegistrationModal from "./modal";
// import { formatDateToDDMMM } from "./comman";
// import { CiLocationOn } from "react-icons/ci";
// import { QRCodeCanvas } from "qrcode.react";
// import Marquee from "./Marquee";
// import "./App.css";
// import MobileNumberAlert from "./MsgModal";
// import InvitationCard from "./InvitationCard";
// import LimitMsgModal from "./LimitMsgModal";
// import VipMessageModal from "./VipMessageModal";

// // Styles
// const useStyles = makeStyles((theme) => ({
//   logo: {
//     maxWidth: "300px", // Default for web
//     height: "auto",
//     margin: "0 auto",
//     display: "block",
//     [theme.breakpoints.down("sm")]: {
//       maxWidth: "200px", // Smaller for mobile
//     },
//   },
//   languageSelect: {
//     margin: theme.spacing(2, 0),
//     minWidth: "50px",
//   },
//   button: {
//     margin: theme.spacing(1),
//   },
//   padding: {
//     padding: theme.spacing(3),
//     // backgroundColor: "#fffcde", // Faint yellow background
//   },
//   input: {
//     // hide MUI underline pseudo-elements (prevents double-lines from global CSS)
//     '& .MuiInput-underline:before, & .MuiInput-underline:after, & .MuiInput-root:before, & .MuiInput-root:after': {
//       display: 'none',
//     },
//     // style the actual input element with a single border-bottom
//     '& .MuiInputBase-input, & input, & textarea': {
//       borderBottom: '1px solid rgba(0,0,0,0.25)',
//       paddingBottom: 8,
//       background: 'transparent',
//       // prevent extra outlines/shadows
//       boxShadow: 'none',
//     },
//     // keep label placement stable
//     '& .MuiInputLabel-root': {
//       transform: 'translate(0, 0.75rem) scale(1)',
//     },
//   },
// }));

// // Validation Schema
// const validationSchema = Yup.object().shape({
//   firstName: Yup.string()
//     .matches(/^[A-Za-z\s]+$/, "Name should only contain letters")
//     .required("Name is required"),

//   // lastName: Yup.string().required("Last Name is required"),

//   mobileNumber: Yup.string()
//     .matches(
//       /^[6-9]\d{9}$/,
//       "Mobile Number must be a valid Indian number starting with 6-9 and 10 digits"
//     )
//     .required("Mobile Number is required"),
//   // email: Yup.string().email("Invalid email format").required("Email is required")
// });

// const VipReg = () => {
//   const params = useParams();
//   const { id } = params;
//   console.log(id);
//   const classes = useStyles();
//   const submitButtonRef = useRef(null);
//   const modalCloseRef = useRef(null);

//   const [selectedLanguage, setSelectedLanguage] = React.useState("English");
//   const [response, setResponse] = useState(null);
//   const [selectedEvent, setSelectedEvent] = useState(null);
//   const [openModal, setOpenModal] = useState(null);
//   const [events, setEvents] = useState([]);
//   const [address, setAddress] = useState("");
//   const [pincode, setPincode] = useState("");
//   const [error, setError] = useState(null);
//   const [open, setOpen] = useState(false);
//   const [lat, setLat] = useState(null);
//   const [long, setLong] = useState(null);
//   const [megaEvents, setMegaEvents] = useState();
//   const [limitMsgOpen, setLimitMsgOpen] = useState(false);
//   const [errorMsg, setErrorMsg] = useState(null);
//   const [location, setLocation] = useState(false);
//   const [openClaim, setOpenClaim] = useState(false);
//   const [limitModalMsgOpen, setLimitModalMsgOpen] = useState(false);
//   const [apiError, setApiError] = useState(null);
//   const [isValidLink, setIsValidLink] = useState(true);
//   // console.log(megaEvents);
//   const today = new Date();
//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);
//   const handleLimitClose = () => {
//     setLimitMsgOpen(false);
//     setErrorMsg(null);
//     setLocation(false);
//   };
//   const [isModalOpen, setModalOpen] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [QRData, setQRData] = useState(null);

//   const [idFile, setIdFile] = useState(null);


//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       // ✅ Check file size (3MB = 3 * 1024 * 1024 bytes)
//       if (file.size > 3 * 1024 * 1024) {
//         alert("File size should not exceed 3 MB!");
//         event.target.value = null; // Reset input
//         return;
//       }
//       setIdFile(file);

//       setTimeout(() => {
//         submitButtonRef.current?.scrollIntoView({
//           behavior: "smooth",
//           block: "center",
//         });
//       }, 100); //
//     }
//   };
//   useEffect(() => {
//     const fetchHexaCodeDetails = async () => {
//       try {
//         const response = await fetch(`/api/hexacode/details/${id}`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Accept: "application/json",
//           },
//         });

//         // console.log(response);

//         // Parse the response JSON first, regardless of status
//         const data = await response.json();

//         if (!response.ok) {
//           // Handle error responses with backend messages
//           setApiError(data.message || "An error occurred");
//           setIsValidLink(false);
//           return;
//         }

//         // Handle successful response
//         if (data.status === "success") {
//           setQRData(data.data);
//           setIsValidLink(true);
//           setApiError(null);
//         } else {
//           console.error("Error in response data:", data);
//           setApiError(data.message || "Invalid response from server");
//           setIsValidLink(false);
//         }
//       } catch (error) {
//         console.error("Fetch error:", error.message);
//         setApiError("Network error. Please check your connection and try again.");
//         setIsValidLink(false);
//       }
//     };

//     if (id) fetchHexaCodeDetails();
//   }, [id, openModal]);


//   const handleModalClose = () => {
//     setModalOpen(false);
//     setOpenClaim(false);
//     setLimitModalMsgOpen(false);
//   };
//   // Extract first two words of the address
//   const getShortAddress = (address) => {
//     const words = address.split(" ");
//     return words.slice(0, 3).join(" ") + (words.length > 2 ? "..." : "");
//   };
//   // console.log(address)
//   // console.log(pincode)

//   useEffect(() => {
//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           const { latitude, longitude } = position.coords;
//           setLat(latitude);
//           setLong(longitude);
//         },
//         (err) => {
//           setError("Unable to retrieve your location");
//           console.error("Error getting location:", err);
//         }
//       );
//     } else {
//       setError("Geolocation is not supported by this browser.");
//       console.error("Geolocation is not supported by this browser.");
//     }
//   }, [location]);

//   const handleLanguageChange = (event) => {
//     setSelectedLanguage(event.target.value);
//   };

//   const handleImageClick = (eventValue, name) => {
//     const checkLimit = events.filter((event) => event.code === eventValue);
//     if (!checkLimit[0].active) {
//       setLimitMsgOpen(true);
//       return setErrorMsg(
//         "This Event is No Longer Active! Thank you for your interest. Stay tuned for upcoming events."
//       );
//       // return alert("This event is not active. Please choose another event.");
//     }
//     if (checkLimit[0].registrationCount >= checkLimit[0].eventLimit) {
//       // setErrorMsg(
//       //   "Current entry pass slots are filled. Check back soon for more availability!"
//       // );
//       // setLimitMsgOpen(true);
//       setSelectedEvent(eventValue);
//       setLimitModalMsgOpen(true);
//       return;

//       // alert(
//       //   "Entry passes are fully booked; the limit has been crossed."
//       // );
//     }
//     if (
//       today < new Date(checkLimit[0]?.startDate) ||
//       today > new Date(checkLimit[0]?.endDate)
//     ) {
//       setLimitMsgOpen(true);
//       return setErrorMsg(
//         "Starting 18th December, secure your online entry pass for the event!"
//       );
//       // return alert(
//       //   "The event has not started yet. Please wait for it to begin."
//       // );
//     }
//     setLimitMsgOpen(true);
//     setErrorMsg(`You selected "${name}" event. Please confirm to proceed.`);
//     setSelectedEvent(eventValue); // Set the selected event
//     setTimeout(() => {
//       submitButtonRef.current?.scrollIntoView({
//         behavior: "smooth",
//         block: "center",
//       });
//     }, 100); //
//   };

//   // Language Mappings
//   const translations = {
//     English: {
//       registerForm: "Fill in the details to register the smart card.",
//       firstName: "Full Name",
//       lastName: "Last Name",
//       mobileNumber: "Mobile Number",
//       email: "Email",
//       register: "REGISTER",
//       android: "Android",
//       ios: "iOS",
//       web: "Web Pass",
//       mobile: "Mobile Pass",
//       selectEventPlaceholder: "Select an Event",
//       event1: "Kumar Vishwas Event 14 December",
//       event2: "Kumar Vishwas Event 15 December",
//       event3: "Kumar Vishwas Event 16 December",
//       event4: "Abhang Vari Event 17 December",
//       event5: "Abhijat Marathi Event 18 December",
//       event6: "Fusion Event 19 December",
//       event7: "Sanam Band Live Event 23 December",
//       event8: "Udit Narayan 21 December",
//       event9: "Vishal Mishra Event 22 December",
//       select: "Choose event",
//       selected: "Selected event",
//       download: "Download Gate Pass",
//       view: "View Gate Pass",
//       line: "Register by filling in the required details to receive your online event pass. Don’t forget to download your pass. Please note, duplicate passes will not be issued. Arrive early and keep your gate pass ready.wwwww",
//       choose: "For All Events",
//       terms: "Terms and Conditions",
//       termsAndConditions: {
//         title: "Terms and Conditions",
//         items: [
//           {
//             title: "First-Come, First-Serve:",
//             description:
//               "Free entry is granted on a first-come, first-serve basis. Holding a free pass does not guarantee entry if the venue reaches capacity.",
//           },
//           {
//             title: "Non-Transferable:",
//             description:
//               "The free entry pass is issued to the individual named on it and is strictly non-transferable. Attempts to sell or exchange the pass will result in cancellation.",
//           },
//           {
//             title: "Age Restriction:",
//             description:
//               "Entry is subject to age verification. Solo attendees must meet the minimum age requirement (16+) and provide valid ID at the entrance.",
//           },
//           {
//             title: "Limited Validity:",
//             description:
//               "The free entry pass is valid only for the specified event date and time. It cannot be redeemed for other events or dates.",
//           },
//           {
//             title: "Right to Refuse Entry:",
//             description:
//               "The organizer reserves the right to deny entry to anyone who fails to comply with the event's dress code, behavioral policies, or safety guidelines, even if they hold a free entry pass.",
//           },
//         ],
//       },
//     },
//     Hindi: {
//       registerForm: "रजिस्टर फॉर्म",
//       firstName: "पूरा नाम",
//       mobileNumber: "मोबाइल नंबर",
//       email: "ईमेल",
//       register: "रजिस्टर करें",
//       android: "एंड्रॉयड",
//       ios: "आईओएस",
//       web: "वेब पास",
//       mobile: "मोबाइल पास",
//       selectEventPlaceholder: "एक कार्यक्रम चुनें",
//       event1: "कुमार विश्वास इवेंट 14 दिसंबर",
//       event2: "कुमार विश्वास इवेंट 15 दिसंबर",
//       event3: "कुमार विश्वास इवेंट 16 दिसंबर",
//       event4: "अभंग वारी इवेंट 17 दिसंबर",
//       event5: "अभिजात मराठी इवेंट 18 दिसंबर",
//       event6: "फ्यूजन इवेंट 19 दिसंबर",
//       event7: "विशाल मिश्रा इवेंट 22 दिसंबर",
//       event8: "उदित नारायण 21 दिसंबर",
//       event9: "विशाल मिश्रा इवेंट 23 दिसंबर",
//       download: "गेट पास डाउनलोड करें",
//       view: "गेट पास देखें",
//       line: "आवश्यक विवरण भरकर पंजीकरण करें और अपना ऑनलाइन इवेंट पास प्राप्त करें। अपना पास डाउनलोड करना न भूलें। कृपया ध्यान दें, डुप्लिकेट पास जारी नहीं किया जाएगा। समय से पहले आएं और अपना गेट पास तैयार रखें।",
//       choose: "सभी इवेंट्स के लिए",
//       selected: "चयनित इवेंट",
//       terms: "नियम और शर्तें",
//       termsAndConditions: {
//         title: "नियम और शर्तें",
//         items: [
//           {
//             title: "पहले आओ, पहले पाओ:",
//             description:
//               "मुफ्त प्रवेश पहले आओ, पहले पाओ के आधार पर दिया जाता है। मुफ्त पास रखने से यह सुनिश्चित नहीं होता कि अगर स्थान भर जाए तो प्रवेश मिलेगा।",
//           },
//           {
//             title: "अप्रत्यावर्तनीय:",
//             description:
//               "मुफ्त प्रवेश पास उस व्यक्ति को जारी किया जाता है जिसका नाम उस पर है और यह स्थानांतरित नहीं किया जा सकता। पास को बेचना या बदलने की कोशिश से रद्द कर दिया जाएगा।",
//           },
//           {
//             title: "उम्र की सीमा:",
//             description:
//               "प्रवेश उम्र की जांच के अधीन है। एकल आगंतुकों को न्यूनतम उम्र की आवश्यकता (16+) पूरी करनी होगी और प्रवेश द्वार पर वैध पहचान पत्र प्रदान करना होगा।",
//           },
//           {
//             title: "सीमित वैधता:",
//             description:
//               "मुफ्त प्रवेश पास केवल निर्दिष्ट इवेंट तिथि और समय के लिए मान्य है। इसे अन्य इवेंट्स या तारीखों के लिए भुनाया नहीं जा सकता।",
//           },
//           {
//             title: "प्रवेश से इनकार करने का अधिकार:",
//             description:
//               "आयोजक को इवेंट के ड्रेस कोड, व्यवहार नीतियों, या सुरक्षा निर्देशों का पालन न करने वालों को प्रवेश देने का अधिकार है, भले ही उनके पास मुफ्त प्रवेश पास हो।",
//           },
//         ],
//       },
//     },
//     Marathi: {
//       registerForm: "उपस्थित राहण्यासाठी नोंदणी",
//       firstName: "पूर्ण नाव",
//       mobileNumber: "मोबाइल नंबर",
//       email: "ईमेल",
//       register: "नोंदणी करा",
//       android: "एंड्रॉइड",
//       ios: "आयओएस",
//       web: "वेब पास",
//       mobile: "मोबाइल पास",
//       selectEventPlaceholder: "एक कार्यक्रम निवडा",
//       event1: "कुमार विश्वास कार्यक्रम 14 डिसेंबर",
//       event2: "कुमार विश्वास कार्यक्रम 15 डिसेंबर",
//       event3: "कुमार विश्वास कार्यक्रम 16 डिसेंबर",
//       event4: "अभंग वारी कार्यक्रम 17 डिसेंबर",
//       event5: "अभिजात मराठी कार्यक्रम 18 डिसेंबर",
//       event6: "फ्यूजन कार्यक्रम 19 डिसेंबर",
//       event7: "उदित नारायण 21 डिसेंबर",
//       event8: "विशाल मिश्रा कार्यक्रम 22 डिसेंबर",
//       event9: "विशाल मिश्रा कार्यक्रम 23 डिसेंबर",
//       download: "गेट पास डाउनलोड करा",
//       view: "गेट पास पहा",
//       line: "आवश्यक तपशील भरून नोंदणी करा आणि आपला ऑनलाइन इव्हेंट पास प्राप्त करा. आपला पास डाउनलोड करायला विसरू नका. कृपया लक्षात घ्या, डुप्लिकेट पास जारी केला जाणार नाही. लवकर या आणि आपला गेट पास तयार ठेवा.",
//       choose: "सर्व इव्हेंट्ससाठी",
//       selected: "निवडलेला कार्यक्रम",
//       terms: " नियम आणि अटी",
//       termsAndConditions: {
//         title: "नियम आणि अटी",
//         items: [
//           {
//             title: "प्रथम ये, प्रथम सेवा:",
//             description:
//               "मोफत प्रवेश प्रथम ये, प्रथम सेवा युक्तीवर दिला जातो. मोफत पास असणे ह्याचा अर्थ नाही की तुम्हाला प्रवेश मिळेल, विशेषतः जर जागा भरलेली असेल.",
//           },
//           {
//             title: "अक्षुण्ण ठेवण्याची अट:",
//             description:
//               "मोफत प्रवेश पास त्या व्यक्तीस दिला जातो ज्याचं नाव त्यावर आहे आणि हा पास हस्तांतरीत केला जाऊ शकत नाही. पास विक्री किंवा हस्तांतरण केल्यास तो रद्द होईल.",
//           },
//           {
//             title: "वयाची अट:",
//             description:
//               "प्रवेश वय तपासणीला अधीन आहे. एकटे येणाऱ्यांनी किमान वयाची अट (१६+) पूर्ण करणे आवश्यक आहे आणि प्रवेशद्वारावर वैध ओळखपत्र देणे आवश्यक आहे.",
//           },
//           {
//             title: "मर्यादित वैधता:",
//             description:
//               "मोफत प्रवेश पास केवळ निर्दिष्ट इव्हेंटच्या तारखेस आणि वेळेस वैध आहे. इतर इव्हेंट्स किंवा तारखांसाठी ते बदलता येणार नाही.",
//           },
//           {
//             title: "प्रवेश नाकारण्याचा अधिकार:",
//             description:
//               "संगठकाला इव्हेंटच्या पोशाख नियम, वर्तन धोरणे किंवा सुरक्षा मार्गदर्शक तत्त्वांचे पालन न करणाऱ्यांना प्रवेश नाकारण्याचा अधिकार आहे, जरी त्यांच्याकडे मोफत प्रवेश पास असेल.",
//           },
//         ],
//       },
//     },
//   };
//   // const findID = () => {
//   //   const evnetID = selectedEvent || id;
//   //   if (evnetID === "GOGI07KSMH") {
//   //     return "6743219da2c442c836d4a7fe";
//   //   } else if (evnetID === "VIMI08KSMH") {
//   //     return "67432233a2c442c836d4a800";
//   //   } else if (evnetID === "FuSo1912KSMH") {
//   //     return "6740d102e25eb4fdeec3e407";
//   //   } else if (evnetID === "SBdL2012KSMH") {
//   //     return "6740d117e25eb4fdeec3e409";
//   //   } else if (evnetID === "UdNn2112KSMH") {
//   //     return "6740d12de25eb4fdeec3e40b";
//   //   } else if (evnetID === "VsMa2212KSMH") {
//   //     return "6740d146e25eb4fdeec3e40d";
//   //   } else if (evnetID === "GrMA1312KSMH") {
//   //     return "6740d076e25eb4fdeec3e3fb";
//   //   } else if (evnetID === "KrVw1412KSMH") {
//   //     return "6740d090e25eb4fdeec3e3fd";
//   //   } else if (evnetID === "KrVw1512KSMH") {
//   //     return "6740d09ce25eb4fdeec3e3ff";
//   //   } else if (evnetID === "KrVw1612KSMH") {
//   //     return "6740d0a7e25eb4fdeec3e401";
//   //   } else if (evnetID === "JbNy2312KSMH") {
//   //     return "675c07393cf59217d48b697c";
//   //   }
//   // };
//   const fetchMegaEvents = async () => {
//     try {
//       const response = await fetch("/api/get/megaEvents", {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//       });

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const data = await response.json();
//       // console.log(data);

//       if (data.status === "success") {
//         setMegaEvents(data.data[0]);
//       } else {
//         console.error("Error in response data:", data);
//       }
//     } catch (error) {
//       console.error("Fetch error:", error.message);
//     }
//   };

//   useEffect(() => {
//     const fetchEvents = async () => {
//       try {
//         const response = await fetch("/api/get/events", {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Accept: "application/json",
//           },
//         });

//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }

//         const data = await response.json();
//         // console.log(data);

//         if (data.status === "success") {
//           setEvents(data.data);
//         } else {
//           console.error("Error in response data:", data);
//         }
//       } catch (error) {
//         console.error("Fetch error:", error.message);
//       }
//     };
//     fetchMegaEvents();
//     fetchEvents();
//   }, []);

//   // console.log(errorMsg);
//   const getDynamicDateMessage = () => {
//     const now = new Date();
//     const nextDay = new Date(now);

//     // Set event time to 11 AM
//     nextDay.setHours(11, 0, 0, 0);

//     // Check if 11 AM has already passed today
//     if (now >= nextDay) {
//       // If passed, move to tomorrow
//       nextDay.setDate(nextDay.getDate() + 1);
//     }

//     // Format the date as "18th December"
//     const options = { day: "numeric", month: "long" };
//     const formattedDate = nextDay.toLocaleDateString("en-US", options);

//     // Determine 'today' or 'tomorrow'
//     const dayLabel =
//       now.toDateString() === nextDay.toDateString() ? "today" : "tomorrow";

//     return `Online entry passes for the event will open ${dayLabel} at 11 AM (${formattedDate}). Secure your spot!`;
//   };

//   const onSubmit = async (values) => {
//     if (loading) return;
//     // if (!idFile) {
//     //   return alert("Please upload ID proof");
//     // }

//     try {
//       setLoading(true);

//       const formData = new FormData();
//       formData.append("firstName", values.firstName);
//       formData.append("mobileNumber", values.mobileNumber);
//       formData.append("designation", values.designation || "");
//       formData.append("organization", values.organization || "");
//       formData.append("address", address);
//       formData.append("pincode", pincode);
//       formData.append("coordinates", JSON.stringify({ lat: lat, lng: long }));
//       formData.append("id", id);
//       idFile && formData.append("idFile", idFile); // Use idFile state, not values.idFile

//       const response = await fetch("/api/vip/save/details", {
//         method: "POST",
//         // Remove Content-Type header - browser will set it automatically with boundary
//         body: formData,
//       });

//       const data = await response.json();

//       if (response.ok) {
//         // setResponse(data);
//         setOpenModal(data.message || "Registration successful");
//         setSelectedEvent(null);
//         setTimeout(() => {
//           modalCloseRef.current?.scrollIntoView({
//             behavior: "smooth",
//             block: "center",
//           });
//         }, 100);
//       } else {
//         console.error("Registration failed:", data);
//         if (data?.status === 400) {
//           setModalOpen(true);
//         } else if (data?.status === 402) {
//           setErrorMsg(data?.message);
//           setLimitMsgOpen(true);
//         } else {
//           alert(data?.message || "Something went wrong");
//         }
//       }
//     } catch (error) {
//       console.error("Error while registering:", error);
//       alert("An error occurred. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };
//   const filteredEvents = events.filter((event) => event.active === true)

//   if (id && events.length === 0 && !apiError) {
//     return (
//       <div style={{
//         minHeight: '100vh',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center'
//       }}>
//         <CircularProgress size={50} />
//       </div>
//     );
//   }
//   return (
//     <div>
//       <Grid container justify="center" spacing={2}>
//         <Grid
//           item
//           style={{ position: "absolute", top: 3, left: 0, cursor: "pointer" }}
//           onClick={handleOpen}
//         >
//           <CiLocationOn size={25} /> <>{getShortAddress(address)}</>
//         </Grid>
//         <Grid item style={{ position: "absolute", top: -15, right: 0 }}>
//           <Select
//             value={selectedLanguage}
//             onChange={handleLanguageChange}
//             className={classes.languageSelect}
//           >
//             <MenuItem value="English">English</MenuItem>
//             <MenuItem value="Hindi">हिंदी</MenuItem>
//             <MenuItem value="Marathi">मराठी</MenuItem>
//           </Select>
//         </Grid>
//         <Dialog open={open} onClose={handleClose}>
//           <DialogTitle>Full Address</DialogTitle>
//           <DialogContent>
//             <Typography variant="body1">{address}</Typography>
//           </DialogContent>
//         </Dialog>
//         {/* Centered Logo */}
//         <Grid
//           item
//           xs={12}
//           style={{ textAlign: "center", backgroundColor: "#fffcde" }}
//         >
//           <img src="/khasdar.jpg" alt="Logo" className={classes.logo} />
//         </Grid>
//         {/* <Marquee data={translations[selectedLanguage].line} /> */}
//         {isValidLink && !apiError ? (
//           <div
//             style={{
//               background: "url('/Banner.png') no-repeat center center", // Replace with your image URL
//               backgroundSize: "cover", // Ensure the image covers the entire area
//               minHeight: "85vh", // Full height of the viewport
//               display: "flex", // To center the Grid
//               justifyContent: "center",
//               alignItems: "center",
//               minWidth: "90%", //
//             }}
//           >
//             <Grid
//               item
//               md={6}
//               xs={12}
//               style={{
//                 background: "linear-gradient(to right, #f8f9fa, #e9ecef)", // Subtle gradient inside the Grid
//                 padding: "16px", // Add spacing around the card
//                 borderRadius: "12px", // Rounded corners for the Grid content
//               }}
//             >
//               <Card
//                 className={classes.padding}
//                 style={{
//                   background: "white", // Clean and simple card background
//                   borderRadius: "12px", // Rounded corners
//                   boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)", // Subtle shadow for depth
//                   transition: "transform 0.3s, box-shadow 0.3s", // Smooth hover animation
//                 }}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.boxShadow =
//                     "0 8px 16px rgba(0, 0, 0, 0.2)"; // Elevated shadow on hover
//                   e.currentTarget.style.transform = "scale(1.05)"; // Slightly enlarge on hover
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.boxShadow =
//                     "0 4px 12px rgba(0, 0, 0, 0.1)"; // Reset shadow
//                   e.currentTarget.style.transform = "scale(1)"; // Reset size
//                 }}
//               >
//                 <p
//                   style={{
//                     fontSize: window.innerWidth < 600 ? "1.3em" : "2em", // smaller on mobile
//                     fontWeight: "bold",
//                     margin: 0,
//                     lineHeight: window.innerWidth < 600 ? "1.1em" : "1.2em", // tighter line spacing on mobile
//                     wordSpacing: window.innerWidth < 600 ? "0em" : "0.05em", // reduced gap on mobile
//                     letterSpacing: "0.02em",
//                     textAlign: "center",
//                   }}
//                 >
//                   {translations[selectedLanguage].registerForm}
//                 </p>



//                 <Formik
//                   initialValues={{
//                     firstName: "",
//                     mobileNumber: "",
//                   }}
//                   validationSchema={validationSchema}
//                   onSubmit={onSubmit}
//                 >
//                   {({ dirty, isValid }) => (
//                     <Form>
//                       <CardContent>
//                         <Grid container spacing={2}>
//                           <Grid item xs={12}>
//                             <Field
//                               label={translations[selectedLanguage].firstName}
//                               variant="standard" // Underline border style
//                               fullWidth
//                               required
//                               name="firstName"
//                               component={TextField}
//                               className={classes.input}
//                             />
//                           </Grid>

//                           <Grid item xs={12}>
//                             <Field
//                               label={
//                                 translations[selectedLanguage].mobileNumber
//                               }
//                               variant="standard" // Underline border style
//                               fullWidth
//                               required
//                               name="mobileNumber"
//                               component={TextField}
//                               className={classes.input}
//                             />
//                           </Grid>
//                           {/* Designation / Title */}
//                           {/* <Grid item xs={12}>
//                             <Field
//                               label="Designation / Title"
//                               variant="standard"
//                               fullWidth
//                               required
//                               name="designation"
//                               component={TextField}
//                               className={classes.input}
//                             />
//                           </Grid> */}

//                           {/* Organization */}
//                           {/* <Grid item xs={12}>
//                             <Field
//                               label="Organization"
//                               variant="standard"
//                               fullWidth
//                               required
//                               name="organization"
//                               component={TextField}
//                               className={classes.input}
//                             />
//                           </Grid> */}

//                           {/* Upload ID */}
//                           {/* <Grid item xs={12}>
//                             <Button
//                               variant="outlined"
//                               component="label"
//                               fullWidth
//                               sx={{
//                                 textTransform: "none",
//                                 display: 'flex',
//                                 gap: 1,
//                                 alignItems: 'center'
//                               }}
//                             >
//                               <svg
//                                 width="24"
//                                 height="24"
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                                 stroke="currentColor"
//                                 strokeWidth="2"
//                               >
//                                 <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
//                                 <polyline points="17 8 12 3 7 8" />
//                                 <line x1="12" y1="3" x2="12" y2="15" />
//                               </svg>
//                               &nbsp;
//                               Upload ID (Max 3 MB)
//                               <input
//                                 type="file"
//                                 hidden
//                                 accept=".jpg,.jpeg,.png,.pdf"
//                                 onChange={handleFileChange}
//                               />
//                             </Button>

//                             {idFile && (
//                               <p style={{ fontSize: "0.9rem", marginTop: "8px", color: "green" }}>
//                                 ✅ Uploaded: {idFile.name} ({(idFile.size / 1024 / 1024).toFixed(2)} MB)
//                               </p>
//                             )}
//                           </Grid> */}
//                           {/* New Dropdown Field */}
//                           <Grid item xs={12}>
//                             <p style={{ fontSize: "1.17em", fontWeight: "bold", margin: 0 }}>
//                               {translations[selectedLanguage].choose}
//                             </p>

//                             <Grid container spacing={2} justifyContent="center">
//                               {filteredEvents.map(
//                                 (event) =>
//                                   <Grid
//                                     item
//                                     key={event.code}
//                                     xs={6}
//                                     sm={4}
//                                     md={3}
//                                     display="flex"
//                                     justifyContent="center"
//                                     direction="column"
//                                     alignItems="center"
//                                   >
//                                     <img
//                                       src={event.imageUrl}
//                                       alt={event.label}
//                                       style={{
//                                         width: "100%",
//                                         height: "auto",
//                                         cursor: "pointer",
//                                         maxWidth: "120px", // Set a max width for images on mobile
//                                         border:
//                                           selectedEvent === event.code
//                                             ? "3px solid #1976d2"
//                                             : "none", // Highlight selected image
//                                         borderRadius: "8px", // Optional: rounded corners
//                                         boxShadow:
//                                           selectedEvent === event.code
//                                             ? "0px 0px 10px rgba(25, 118, 210, 0.5)"
//                                             : "none", // Optional: add shadow for selected
//                                         animation:
//                                           "hoverEffect 2s infinite ease-in-out", // Apply animation
//                                       }}
//                                     // onClick={() =>
//                                     //   handleImageClick(
//                                     //     event.code,
//                                     //     event?.eventName
//                                     //   )
//                                     // } // Handle image click to select
//                                     />

//                                     <Typography
//                                       variant="body2"
//                                       align="center"
//                                       style={{
//                                         marginTop: "2px",
//                                         // fontWeight: "600",
//                                       }}
//                                     >
//                                       {event.eventDate &&
//                                         formatDateToDDMMM(event.eventDate)}
//                                     </Typography>
//                                   </Grid>
//                                 // )
//                                 // )
//                               )}
//                             </Grid>
//                           </Grid>
//                         </Grid>
//                       </CardContent>
//                       <Button
//                         ref={submitButtonRef}
//                         disabled={loading} // Disable when loading
//                         variant="contained"
//                         color="primary"
//                         type="submit"
//                         className={classes.button}
//                         style={{
//                           padding: "10px 30px",
//                           fontSize: "18px",
//                           fontWeight: "bold",
//                           borderRadius: "30px",
//                           background: loading
//                             ? "linear-gradient(135deg, #bbb, #ddd)" // Dim color for loading state
//                             : "linear-gradient(135deg, #cc5200, #b065a1)",
//                           color: "white",
//                           textTransform: "uppercase",
//                           boxShadow: loading
//                             ? "none"
//                             : "0 4px 10px rgba(255, 127, 50, 0.3)",
//                           transition:
//                             "transform 0.3s ease, box-shadow 0.3s ease",
//                         }}
//                         onMouseEnter={(e) => {
//                           if (!loading) {
//                             e.target.style.transform = "scale(1.05)";
//                             e.target.style.boxShadow =
//                               "0 6px 15px rgba(255, 127, 50, 0.5)";
//                           }
//                         }}
//                         onMouseLeave={(e) => {
//                           if (!loading) {
//                             e.target.style.transform = "scale(1)";
//                             e.target.style.boxShadow =
//                               "0 4px 10px rgba(255, 127, 50, 0.3)";
//                           }
//                         }}
//                       >
//                         {loading ? (
//                           <CircularProgress
//                             size={24}
//                             style={{ color: "white" }}
//                           />
//                         ) : (
//                           translations[selectedLanguage].register
//                         )}
//                       </Button>
//                     </Form>
//                   )}
//                 </Formik>
//               </Card>
//             </Grid>
//           </div>
//         ) : (
// <p
//   style={{
//     fontSize: "20px",
//     fontWeight: "600",
//     color: "#FF5733",
//     textAlign: "center",
//     lineHeight: "1.4",
//     padding: "12px 16px",
//     wordWrap: "break-word",
//   }}
// >
//   {apiError ||
//     "Registration is already completed or link has been used. Visit the event with your invite smart card."}
// </p>

//         )}
//       </Grid>
//       <VipMessageModal
//         open={openModal}
//         onClose={() => setOpenModal(false)}
//         modalCloseRef={modalCloseRef}
//         message={openModal}
//       // onDownload={handleDownload}
//       />
//       <MobileNumberAlert
//         open={isModalOpen}
//         onClose={handleModalClose}
//         openClaim={openClaim}
//         setOpenClaim={setOpenClaim}
//         setResponse={setResponse}
//       // selectedEvent={findID()}
//       />
//       <LimitMsgModal
//         open={limitModalMsgOpen}
//         onClose={handleModalClose}
//         openClaim={openClaim}
//         setOpenClaim={setOpenClaim}
//         setResponse={setResponse}
//       // selectedEvent={findID()}
//       />

//       {response && (
//         <InvitationCard
//           event={response}
//           selectedEvent={selectedEvent || id}
//           download={translations[selectedLanguage].download}
//           view={translations[selectedLanguage].view}
//           modalCloseRef={modalCloseRef}
//         />
//       )}

//       {/* <div
//         style={{
//           maxWidth: "600px", // Limit the width to a card size
//           margin: "0 auto", // Center the content horizontally
//           textAlign: "left", // Keep the text alignment left
//           padding: "16px", // Add some padding for spacing
//         }}
//       >
//         <h4 style={{ marginBottom: "10px", paddingLeft: "10px" }}>
//           {translations[selectedLanguage].terms}
//         </h4>
//         <small>
//           <ul style={{ listStyleType: "disc", paddingLeft: "20px", margin: 0 }}>
//             {currentTranslations.items.map((item, index) => (
//               <li key={index}>
//                 <strong>{item.title}</strong> {item.description}
//               </li>
//             ))}
//           </ul>
//         </small>
//       </div> */}
//       <div
//         style={{
//           background: "linear-gradient(to right, #2A5D87, #004AAD, #002A52)", // Footer background gradient
//           padding: "10px 15px", // Padding for spacing
//           display: "flex", // Flexbox for alignment
//           justifyContent: "center", // Center content horizontally
//           alignItems: "center", // Center content vertically
//           textAlign: "center", // Align text in the center
//           color: "white", // Text color
//           fontSize: "14px", // Adjust text size for responsiveness
//           fontFamily: "'Arial', sans-serif", // Clean font
//         }}
//       >
//         <a
//           href="https://www.bharat-online.com/"
//           target="_blank" // Opens link in a new tab
//           rel="noopener noreferrer" // Security measure
//           style={{ textDecoration: "none", color: "inherit" }} // Remove underline and use parent color
//         >
//           <span style={{ display: "flex", alignItems: "center" }}>
//             Developed and Maintained By
//             <img
//               src="/bharatOnline.png"
//               alt="bharatOnline"
//               crossOrigin="anonymous"
//               style={{
//                 marginLeft: "6px", // Space between text and image
//                 marginRight: "6px", // Space after image
//                 height: "25px", // Set image size
//               }}
//             />
//             <span style={{ fontWeight: "bold" }}>Bharat Online</span>
//           </span>
//         </a>
//       </div>


//       <Dialog open={limitMsgOpen} onClose={handleLimitClose}>
//         <DialogTitle>{errorMsg}</DialogTitle>

//         <DialogActions>
//           <Button onClick={handleLimitClose} color="primary">
//             OK
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// };

// export default VipReg;

import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  makeStyles,
  Card,
  CardContent,
  Button,
  CardHeader,
  Select,
  MenuItem,
  Typography,
  ThemeProvider,
  createTheme,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
  DialogActions,
  Chip,
} from "@material-ui/core";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { TextField } from "formik-material-ui";
import Receipt from "./receipt";
import { Link, useParams } from "react-router-dom";
import RegistrationModal from "./modal";
import { formatDateToDDMMM } from "./comman";
import { CiLocationOn } from "react-icons/ci";
import { QRCodeCanvas } from "qrcode.react";
import Marquee from "./Marquee";
import "./App.css";
import MobileNumberAlert from "./MsgModal";
import InvitationCard from "./InvitationCard";
import LimitMsgModal from "./LimitMsgModal";
import VipMessageModal from "./VipMessageModal";
import VipInvitation from "./VipInvitation";

// Styles
const useStyles = makeStyles((theme) => ({
  logo: {
    maxWidth: "300px", // Default for web
    height: "auto",
    margin: "0 auto",
    display: "block",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "200px", // Smaller for mobile
    },
  },
  languageSelect: {
    margin: theme.spacing(2, 0),
    minWidth: "50px",
  },
  button: {
    margin: theme.spacing(1),
  },
  padding: {
    padding: theme.spacing(3),
    // backgroundColor: "#fffcde", // Faint yellow background
  },
  input: {
    // hide MUI underline pseudo-elements (prevents double-lines from global CSS)
    '& .MuiInput-underline:before, & .MuiInput-underline:after, & .MuiInput-root:before, & .MuiInput-root:after': {
      display: 'none',
    },
    // style the actual input element with a single border-bottom
    '& .MuiInputBase-input, & input, & textarea': {
      borderBottom: '1px solid rgba(0,0,0,0.25)',
      paddingBottom: 8,
      background: 'transparent',
      // prevent extra outlines/shadows
      boxShadow: 'none',
    },
    // keep label placement stable
    '& .MuiInputLabel-root': {
      transform: 'translate(0, 0.75rem) scale(1)',
    },
  },
  eventImage: {
    width: "100%",
    height: "auto",
    cursor: "pointer",
    maxWidth: "120px",
    borderRadius: "8px",
    transition: "all 0.3s ease",
    border: "3px solid transparent",
    '&:hover': {
      transform: "scale(1.05)",
    },
  },
  selectedEvent: {
    border: "3px solid #1976d2",
    boxShadow: "0px 0px 10px rgba(25, 118, 210, 0.5)",
  },
  eventCounter: {
    backgroundColor: "#1976d2",
    color: "white",
    borderRadius: "50%",
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: "bold",
    position: "absolute",
    top: "-8px",
    right: "-8px",
  },
  eventItem: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  selectedEventsSummary: {
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
    padding: "16px",
    margin: "16px 0",
    border: "1px solid #e0e0e0",
  },
  chipContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    marginTop: "8px",
  },
}));

// Validation Schema
const validationSchema = Yup.object().shape({
  firstName: Yup.string()
    .matches(/^[A-Za-z\s]+$/, "Name should only contain letters")
    .required("Name is required"),
  mobileNumber: Yup.string()
    .matches(
      /^[6-9]\d{9}$/,
      "Mobile Number must be a valid Indian number starting with 6-9 and 10 digits"
    )
    .required("Mobile Number is required"),
});

const VipReg = () => {
  const params = useParams();
  const { id } = params;
  //console.log(id);
  const classes = useStyles();
  const submitButtonRef = useRef(null);
  const modalCloseRef = useRef(null);

  const [selectedLanguage, setSelectedLanguage] = React.useState("English");
  const [response, setResponse] = useState(null);
  const [selectedEvents, setSelectedEvents] = useState([]); // Changed to array for multiple selection
  const [openModal, setOpenModal] = useState(null);
  const [events, setEvents] = useState([]);
  const [address, setAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  const [lat, setLat] = useState(null);
  const [long, setLong] = useState(null);
  const [megaEvents, setMegaEvents] = useState();
  const [limitMsgOpen, setLimitMsgOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [location, setLocation] = useState(false);
  const [openClaim, setOpenClaim] = useState(false);
  const [limitModalMsgOpen, setLimitModalMsgOpen] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [isValidLink, setIsValidLink] = useState(true);
  const today = new Date();
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleLimitClose = () => {
    setLimitMsgOpen(false);
    setErrorMsg(null);
    setLocation(false);
  };
  const [isModalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [QRData, setQRData] = useState(null);
  const [idFile, setIdFile] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // ✅ Check file size (3MB = 3 * 1024 * 1024 bytes)
      if (file.size > 5 * 1024 * 1024) {
        alert("File size should not exceed 5 MB!");
        event.target.value = null; // Reset input
        return;
      }
      setIdFile(file);

      setTimeout(() => {
        submitButtonRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 100);
    }
  };

  useEffect(() => {
    const fetchHexaCodeDetails = async () => {
      try {
        const response = await fetch(`/api/hexacode/details/${id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });


        // Parse the response JSON first, regardless of status
        const data = await response.json();
        console.log(data);

        if (!response.ok) {
          // Handle error responses with backend messages
          setApiError(data.message || "An error occurred");
          setIsValidLink(false);
          return;
        }

        // Handle successful response
        if (data.status === "success") {
          setQRData(data.data);
          setIsValidLink(true);
          setApiError(null);
        } else {
          console.error("Error in response data:", data);
          setApiError(data.message || "Invalid response from server");
          setIsValidLink(false);
        }
      } catch (error) {
        console.error("Fetch error:", error.message);
        setApiError("Network error. Please check your connection and try again.");
        setIsValidLink(false);
      }
    };

    if (id) fetchHexaCodeDetails();
  }, [id, openModal]);

  const handleModalClose = () => {
    setModalOpen(false);
    setOpenClaim(false);
    setLimitModalMsgOpen(false);
  };

  // Extract first two words of the address
  const getShortAddress = (address) => {
    const words = address.split(" ");
    return words.slice(0, 3).join(" ") + (words.length > 2 ? "..." : "");
  };

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLat(latitude);
          setLong(longitude);
        },
        (err) => {
          setError("Unable to retrieve your location");
          console.error("Error getting location:", err);
        }
      );
    } else {
      setError("Geolocation is not supported by this browser.");
      console.error("Geolocation is not supported by this browser.");
    }
  }, [location]);

  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.value);
  };

  const formatDateToYYYYMMDD = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  // Handle multiple event selection
  const handleEventToggle = (eventValue, name) => {
    const checkLimit = events.filter((event) => event.code === eventValue);

    if (!checkLimit[0].active) {
      setLimitMsgOpen(true);
      return setErrorMsg(
        "This Event is No Longer Active! Thank you for your interest. Stay tuned for upcoming events."
      );
    }

    // if (checkLimit[0].registrationCount >= checkLimit[0].eventLimit) {
    //   setLimitMsgOpen(true);
    //   return setErrorMsg(
    //     `"${name}" event is fully booked. Please select another event.`
    //   );
    // }

    // if (
    //   today < new Date(checkLimit[0]?.startDate) ||
    //   today > new Date(checkLimit[0]?.endDate)
    // ) {
    //   setLimitMsgOpen(true);
    //   return setErrorMsg(
    //     `"${name}" event registration is not available at this time.`
    //   );
    // }

    setSelectedEvents(prev => {
      const isAlreadySelected = prev.some(event => event.code === eventValue);

      if (isAlreadySelected) {
        // Remove event if already selected
        return prev.filter(event => event.code !== eventValue);
      } else {
        // Add event if not selected
        return [...prev, {
          code: eventValue,
          name: name,
          eventDate: formatDateToYYYYMMDD(checkLimit[0].eventDate),
          eventId: checkLimit[0]._id // Assuming event has _id field
        }];
      }
    });
  };

  // Remove selected event
  const handleRemoveEvent = (eventCode) => {
    setSelectedEvents(prev => prev.filter(event => event.code !== eventCode));
  };

  // Language Mappings
  const translations = {
    English: {
      registerForm: "Fill in the details to activate your smart card",
      firstName: "Full Name",
      mobileNumber: "Mobile Number",
      email: "Email",
      register: "REGISTER",
      selectEvents: "Select Events to Attend",
      selectedEvents: "Selected Events",
      eventsSelected: "events selected",
      noEventsSelected: "No events selected yet",
      remove: "Remove",
      android: "Android",
      ios: "iOS",
      web: "Web Pass",
      mobile: "Mobile Pass",
      selectEventPlaceholder: "Select an Event",
      event1: "Kumar Vishwas Event 14 December",
      event2: "Kumar Vishwas Event 15 December",
      event3: "Kumar Vishwas Event 16 December",
      event4: "Abhang Vari Event 17 December",
      event5: "Abhijat Marathi Event 18 December",
      event6: "Fusion Event 19 December",
      event7: "Sanam Band Live Event 23 December",
      event8: "Udit Narayan 21 December",
      event9: "Vishal Mishra Event 22 December",
      select: "Choose event",
      selected: "Selected event",
      download: "Download Gate Pass",
      view: "View Gate Pass",
      line: "Register by filling in the required details to receive your online event pass. Don't forget to download your pass. Please note, duplicate passes will not be issued. Arrive early and keep your gate pass ready.",
      choose: "All Events",
      terms: "Terms and Conditions",
      termsAndConditions: {
        title: "Terms and Conditions",
        items: [
          {
            title: "First-Come, First-Serve:",
            description:
              "Free entry is granted on a first-come, first-serve basis. Holding a free pass does not guarantee entry if the venue reaches capacity.",
          },
          {
            title: "Non-Transferable:",
            description:
              "The free entry pass is issued to the individual named on it and is strictly non-transferable. Attempts to sell or exchange the pass will result in cancellation.",
          },
          {
            title: "Age Restriction:",
            description:
              "Entry is subject to age verification. Solo attendees must meet the minimum age requirement (16+) and provide valid ID at the entrance.",
          },
          {
            title: "Limited Validity:",
            description:
              "The free entry pass is valid only for the specified event date and time. It cannot be redeemed for other events or dates.",
          },
          {
            title: "Right to Refuse Entry:",
            description:
              "The organizer reserves the right to deny entry to anyone who fails to comply with the event's dress code, behavioral policies, or safety guidelines, even if they hold a free entry pass.",
          },
        ],
      },
    },
    Hindi: {
      registerForm: "रजिस्टर फॉर्म",
      firstName: "पूरा नाम",
      mobileNumber: "मोबाइल नंबर",
      email: "ईमेल",
      register: "रजिस्टर करें",
      selectEvents: "भाग लेने के लिए इवेंट चुनें",
      selectedEvents: "चयनित इवेंट",
      eventsSelected: "इवेंट चयनित",
      noEventsSelected: "अभी कोई इवेंट चयनित नहीं",
      remove: "हटाएं",
      android: "एंड्रॉयड",
      ios: "आईओएस",
      web: "वेब पास",
      mobile: "मोबाइल पास",
      selectEventPlaceholder: "एक कार्यक्रम चुनें",
      event1: "कुमार विश्वास इवेंट 14 दिसंबर",
      event2: "कुमार विश्वास इवेंट 15 दिसंबर",
      event3: "कुमार विश्वास इवेंट 16 दिसंबर",
      event4: "अभंग वारी इवेंट 17 दिसंबर",
      event5: "अभिजात मराठी इवेंट 18 दिसंबर",
      event6: "फ्यूजन इवेंट 19 दिसंबर",
      event7: "विशाल मिश्रा इवेंट 22 दिसंबर",
      event8: "उदित नारायण 21 दिसंबर",
      event9: "विशाल मिश्रा इवेंट 23 दिसंबर",
      download: "गेट पास डाउनलोड करें",
      view: "गेट पास देखें",
      line: "आवश्यक विवरण भरकर पंजीकरण करें और अपना ऑनलाइन इवेंट पास प्राप्त करें। अपना पास डाउनलोड करना न भूलें। कृपया ध्यान दें, डुप्लिकेट पास जारी नहीं किया जाएगा। समय से पहले आएं और अपना गेट पास तैयार रखें।",
      choose: "इवेंट चुनें",
      selected: "चयनित इवेंट",
      terms: "नियम और शर्तें",
      termsAndConditions: {
        title: "नियम और शर्तें",
        items: [
          {
            title: "पहले आओ, पहले पाओ:",
            description:
              "मुफ्त प्रवेश पहले आओ, पहले पाओ के आधार पर दिया जाता है। मुफ्त पास रखने से यह सुनिश्चित नहीं होता कि अगर स्थान भर जाए तो प्रवेश मिलेगा।",
          },
          {
            title: "अप्रत्यावर्तनीय:",
            description:
              "मुफ्त प्रवेश पास उस व्यक्ति को जारी किया जाता है जिसका नाम उस पर है और यह स्थानांतरित नहीं किया जा सकता। पास को बेचना या बदलने की कोशिश से रद्द कर दिया जाएगा।",
          },
          {
            title: "उम्र की सीमा:",
            description:
              "प्रवेश उम्र की जांच के अधीन है। एकल आगंतुकों को न्यूनतम उम्र की आवश्यकता (16+) पूरी करनी होगी और प्रवेश द्वार पर वैध पहचान पत्र प्रदान करना होगा।",
          },
          {
            title: "सीमित वैधता:",
            description:
              "मुफ्त प्रवेश पास केवल निर्दिष्ट इवेंट तिथि और समय के लिए मान्य है। इसे अन्य इवेंट्स या तारीखों के लिए भुनाया नहीं जा सकता।",
          },
          {
            title: "प्रवेश से इनकार करने का अधिकार:",
            description:
              "आयोजक को इवेंट के ड्रेस कोड, व्यवहार नीतियों, या सुरक्षा निर्देशों का पालन न करने वालों को प्रवेश देने का अधिकार है, भले ही उनके पास मुफ्त प्रवेश पास हो।",
          },
        ],
      },
    },
    Marathi: {
      registerForm: "उपस्थित राहण्यासाठी नोंदणी",
      firstName: "पूर्ण नाव",
      mobileNumber: "मोबाइल नंबर",
      email: "ईमेल",
      register: "नोंदणी करा",
      selectEvents: "उपस्थित राहण्यासाठी इव्हेंट निवडा",
      selectedEvents: "निवडलेले इव्हेंट",
      eventsSelected: "इव्हेंट निवडले",
      noEventsSelected: "अद्याप कोणतेही इव्हेंट निवडलेले नाही",
      remove: "काढा",
      android: "एंड्रॉइड",
      ios: "आयओएस",
      web: "वेब पास",
      mobile: "मोबाइल पास",
      selectEventPlaceholder: "एक कार्यक्रम निवडा",
      event1: "कुमार विश्वास कार्यक्रम 14 डिसेंबर",
      event2: "कुमार विश्वास कार्यक्रम 15 डिसेंबर",
      event3: "कुमार विश्वास कार्यक्रम 16 डिसेंबर",
      event4: "अभंग वारी कार्यक्रम 17 डिसेंबर",
      event5: "अभिजात मराठी कार्यक्रम 18 डिसेंबर",
      event6: "फ्यूजन कार्यक्रम 19 डिसेंबर",
      event7: "उदित नारायण 21 डिसेंबर",
      event8: "विशाल मिश्रा कार्यक्रम 22 डिसेंबर",
      event9: "विशाल मिश्रा कार्यक्रम 23 डिसेंबर",
      download: "गेट पास डाउनलोड करा",
      view: "गेट पास पहा",
      line: "आवश्यक तपशील भरून नोंदणी करा आणि आपला ऑनलाइन इव्हेंट पास प्राप्त करा. आपला पास डाउनलोड करायला विसरू नका. कृपया लक्षात घ्या, डुप्लिकेट पास जारी केला जाणार नाही. लवकर या आणि आपला गेट पास तयार ठेवा.",
      choose: "इव्हेंट निवडा",
      selected: "निवडलेला कार्यक्रम",
      terms: " नियम आणि अटी",
      termsAndConditions: {
        title: "नियम आणि अटी",
        items: [
          {
            title: "प्रथम ये, प्रथम सेवा:",
            description:
              "मोफत प्रवेश प्रथम ये, प्रथम सेवा युक्तीवर दिला जातो. मोफत पास असणे ह्याचा अर्थ नाही की तुम्हाला प्रवेश मिळेल, विशेषतः जर जागा भरलेली असेल.",
          },
          {
            title: "अक्षुण्ण ठेवण्याची अट:",
            description:
              "मोफत प्रवेश पास त्या व्यक्तीस दिला जातो ज्याचं नाव त्यावर आहे आणि हा पास हस्तांतरीत केला जाऊ शकत नाही. पास विक्री किंवा हस्तांतरण केल्यास तो रद्द होईल.",
          },
          {
            title: "वयाची अट:",
            description:
              "प्रवेश वय तपासणीला अधीन आहे. एकटे येणाऱ्यांनी किमान वयाची अट (१६+) पूर्ण करणे आवश्यक आहे आणि प्रवेशद्वारावर वैध ओळखपत्र देणे आवश्यक आहे.",
          },
          {
            title: "मर्यादित वैधता:",
            description:
              "मोफत प्रवेश पास केवळ निर्दिष्ट इव्हेंटच्या तारखेस आणि वेळेस वैध आहे. इतर इव्हेंट्स किंवा तारखांसाठी ते बदलता येणार नाही.",
          },
          {
            title: "प्रवेश नाकारण्याचा अधिकार:",
            description:
              "संगठकाला इव्हेंटच्या पोशाख नियम, वर्तन धोरणे किंवा सुरक्षा मार्गदर्शक तत्त्वांचे पालन न करणाऱ्यांना प्रवेश नाकारण्याचा अधिकार आहे, जरी त्यांच्याकडे मोफत प्रवेश पास असेल.",
          },
        ],
      },
    },
  };

  const fetchMegaEvents = async () => {
    try {
      const response = await fetch("/api/get/megaEvents", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (data.status === "success") {
        setMegaEvents(data.data[0]);
      } else {
        console.error("Error in response data:", data);
      }
    } catch (error) {
      console.error("Fetch error:", error.message);
    }
  };

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch("/api/get/events", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        if (data.status === "success") {
          setEvents(data.data);

          // ✅ AUTOMATICALLY SELECT ALL ACTIVE EVENTS
          const activeEvents = data.data.filter(event => event.active === true);
          const defaultSelectedEvents = activeEvents.map(event => ({
            code: event.code,
            name: event.eventName,
            eventDate: formatDateToYYYYMMDD(event.eventDate),
            eventId: event._id
          }));

          // Only set default selection if no events are selected yet and not from referral
          if (!QRData?.referralCode) {
            // console.log("defaultSelectedEvents", defaultSelectedEvents);
            setSelectedEvents(defaultSelectedEvents);
          }
        } else {
          console.error("Error in response data:", data);
        }
      } catch (error) {
        console.error("Fetch error:", error.message);
      }
    };
    fetchMegaEvents();
    fetchEvents();
  }, []);

  // const onSubmit = async (values) => {
  //   // console.log(selectedEvents)
  //   // return
  //   if (loading) return;
  //   if (!idFile && !QRData?.referralCode) {
  //     return alert("Please upload ID proof");
  //   }
  //   if (selectedEvents.length === 0 && !QRData?.referralCode) {
  //     return alert("Please select at least one event to attend");
  //   }

  //   try {
  //     setLoading(true);

  //     // Prepare attendance array with event IDs and dates
  //     const attendance = selectedEvents.map(event => ({
  //       eventId: event.eventId,
  //       date: event.eventDate,
  //       // eventCode: event.code
  //     }));

  //     const formData = new FormData();
  //     formData.append("firstName", values.firstName);
  //     formData.append("mobileNumber", values.mobileNumber);
  //     values.referralCode && formData.append("referralCode", values.referralCode);
  //     formData.append("organization", values.organization || "");
  //     formData.append("address", address);
  //     formData.append("pincode", pincode);
  //     formData.append("coordinates", JSON.stringify({ lat: lat, lng: long }));
  //     formData.append("id", id);
  //     idFile && formData.append("idFile", idFile);
  //     attendance && formData.append("attendance", JSON.stringify(attendance)); // Add attendance array

  //     const response = await fetch("/api/vip/save/details", {
  //       method: "POST",
  //       body: formData,
  //     });

  //     const data = await response.json();

  //     if (response.ok) {
  //       setOpenModal(data.message || "Registration successful");
  //       setSelectedEvents([]);
  //       setTimeout(() => {
  //         modalCloseRef.current?.scrollIntoView({
  //           behavior: "smooth",
  //           block: "center",
  //         });
  //       }, 100);
  //     } else {
  //       console.error("Registration failed:", data);
  //       if (data?.status === 400) {
  //         setModalOpen(true);
  //       } else if (data?.status === 402) {
  //         setErrorMsg(data?.message);
  //         setLimitMsgOpen(true);
  //       } else {
  //         alert(data?.message || "Something went wrong");
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error while registering:", error);
  //     alert("An error occurred. Please try again later.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const onSubmit = async (values) => {
    if (loading) return;
    // if (!idFile && !QRData?.referralCode) {
    //   return alert("Please upload ID proof");
    // }
    if (selectedEvents.length === 0 && !QRData?.referralCode) {
      return alert("Please select at least one event to attend");
    }

    try {
      setLoading(true);

      // Prepare attendance array with event IDs and dates
      const attendance = selectedEvents.map(event => ({
        eventId: event.eventId,
        date: event.eventDate,
      }));
      // console.log("attendance",attendance)
      const formData = new FormData();
      formData.append("firstName", values.firstName);
      formData.append("mobileNumber", values.mobileNumber);
      values.referralCode && formData.append("referralCode", values.referralCode);
      formData.append("inviteCode", values.inviteCode || "");
      formData.append("address", address);
      formData.append("pincode", pincode);
      formData.append("coordinates", JSON.stringify({ lat: lat, lng: long }));
      formData.append("id", id);
      idFile && formData.append("idFile", idFile);
      attendance && !QRData?.referralCode && formData.append("attendance", JSON.stringify(attendance));

      const response = await fetch("/api/vip/save/details", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      console.log("data", data)
      if (response.ok) {
        setOpenModal(data.message || "Registration successful");

        // ✅ Set response data for pass generation
        setResponse(data); // Make sure backend returns full data

        setSelectedEvents([]);
        setTimeout(() => {
          modalCloseRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }, 100);
      } else {
        console.error("Registration failed:", data);
        if (data?.status === 400) {
          setModalOpen(true);
        } else if (data?.status === 402) {
          setErrorMsg(data?.message);
          setLimitMsgOpen(true);
        } else {
          alert(data?.message || "Something went wrong");
        }
      }
    } catch (error) {
      console.error("Error while registering:", error);
      alert("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  const filteredEvents = events.filter((event) => event.active === true);

  if (id && events.length === 0 && !apiError) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <CircularProgress size={50} />
      </div>
    );
  }

  return (
    <div>
      <Grid container justify="center" spacing={2}>
        <Grid
          item
          style={{ position: "absolute", top: 3, left: 0, cursor: "pointer" }}
          onClick={handleOpen}
        >
          <CiLocationOn size={25} /> <>{getShortAddress(address)}</>
        </Grid>
        <Grid item style={{ position: "absolute", top: -15, right: 0 }}>
          <Select
            value={selectedLanguage}
            onChange={handleLanguageChange}
            className={classes.languageSelect}
          >
            <MenuItem value="English">English</MenuItem>
            <MenuItem value="Hindi">हिंदी</MenuItem>
            <MenuItem value="Marathi">मराठी</MenuItem>
          </Select>
        </Grid>
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Full Address</DialogTitle>
          <DialogContent>
            <Typography variant="body1">{address}</Typography>
          </DialogContent>
        </Dialog>

        {/* Centered Logo */}
        <Grid
          item
          xs={12}
          style={{ textAlign: "center", backgroundColor: "#fffcde" }}
        >
          <img src="/khasdar.jpg" alt="Logo" className={classes.logo} />
        </Grid>

        {isValidLink && !apiError ? (
          <div
            style={{
              background: "url('/Banner.png') no-repeat center center",
              backgroundSize: "cover",
              minHeight: "85vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minWidth: "90%",
            }}
          >
            <Grid
              item
              md={6}
              xs={12}
              style={{
                background: "linear-gradient(to right, #f8f9fa, #e9ecef)",
                padding: "16px",
                borderRadius: "12px",
              }}
            >
              <Card
                className={classes.padding}
                style={{
                  background: "white",
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                  transition: "transform 0.3s, box-shadow 0.3s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "0 8px 16px rgba(0, 0, 0, 0.2)";
                  e.currentTarget.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
                  e.currentTarget.style.transform = "scale(1)";
                }}
              >
                <p
                  style={{
                    fontSize: window.innerWidth < 600 ? "1.3em" : "2em",
                    fontWeight: "bold",
                    margin: 0,
                    lineHeight: window.innerWidth < 600 ? "1.1em" : "1.2em",
                    wordSpacing: window.innerWidth < 600 ? "0em" : "0.05em",
                    letterSpacing: "0.02em",
                    textAlign: "center",
                  }}
                >
                  {translations[selectedLanguage].registerForm}
                </p>

                <Formik
                  initialValues={{
                    firstName: "",
                    mobileNumber: "",
                  }}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                >
                  {({ dirty, isValid }) => (
                    <Form>
                      <CardContent>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <Field
                              label={translations[selectedLanguage].firstName}
                              variant="standard"
                              fullWidth
                              required
                              name="firstName"
                              component={TextField}
                              className={classes.input}
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <Field
                              label={translations[selectedLanguage].mobileNumber}
                              variant="standard"
                              fullWidth
                              required
                              name="mobileNumber"
                              component={TextField}
                              className={classes.input}
                            />
                          </Grid>

                          {QRData?.referralCode && (
                            <Grid item xs={12}>
                              <Field
                                label="Referral Code"
                                variant="standard"
                                fullWidth
                                required
                                name="referralCode"
                                component={TextField}
                                className={classes.input}
                              />
                            </Grid>
                          )}


                          {!QRData?.referralCode && (
                            <>
                              {/* <Grid item xs={12}>
                                <Button
                                  variant="outlined"
                                  component="label"
                                  fullWidth
                                  sx={{
                                    textTransform: "none",
                                    display: 'flex',
                                    gap: 1,
                                    alignItems: 'center'
                                  }}
                                >
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                  >
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                    <polyline points="17 8 12 3 7 8" />
                                    <line x1="12" y1="3" x2="12" y2="15" />
                                  </svg>
                                  &nbsp;
                                  Upload ID Proof (Max 5 MB)
                                  <input
                                    type="file"
                                    hidden
                                    accept=".jpg,.jpeg,.png,.pdf"
                                    onChange={handleFileChange}
                                  />
                                </Button>

                                {idFile && (
                                  <p style={{ fontSize: "0.9rem", marginTop: "8px", color: "green" }}>
                                    ✅ Uploaded: {idFile.name} ({(idFile.size / 1024 / 1024).toFixed(2)} MB)
                                  </p>
                                )}
                              </Grid> */}
                              <Grid item xs={12}>
                                <Field
                                  label="Invitation Number"
                                  variant="standard"
                                  fullWidth
                                  required
                                  name="inviteCode"
                                  component={TextField}
                                  className={classes.input}
                                />
                              </Grid>
                              {/* Selected Events Summary */}
                              {selectedEvents.length > 0 && (
                                <Grid item xs={12}>
                                  <div className={classes.selectedEventsSummary}>
                                    <Typography variant="h6" gutterBottom>
                                      {translations[selectedLanguage].selectedEvents} ({selectedEvents.length} {translations[selectedLanguage].eventsSelected})
                                    </Typography>
                                    {/* <div className={classes.chipContainer}>
                                  {selectedEvents.map((event) => (
                                    <Chip
                                      key={event.code}
                                      label={`${event.name} (${formatDateToDDMMM(event.eventDate)})`}
                                      onDelete={() => handleRemoveEvent(event.code)}
                                      color="primary"
                                      variant="outlined"
                                    />
                                  ))}
                                </div> */}
                                    <div className={classes.chipContainer}>
                                      {selectedEvents.map((event) => {
                                        // Truncate long event names for mobile
                                        const displayName = window.innerWidth < 600
                                          ? event.name.length > 25
                                            ? event.name.substring(0, 25) + '...'
                                            : event.name
                                          : event.name;

                                        return (
                                          <Chip
                                            key={event.code}
                                            label={`${displayName} (${formatDateToDDMMM(event.eventDate)})`}
                                            onDelete={() => handleRemoveEvent(event.code)}
                                            color="primary"
                                            variant="outlined"
                                            style={{
                                              maxWidth: window.innerWidth < 600 ? '200px' : 'none',
                                              marginBottom: '4px'
                                            }}
                                          />
                                        );
                                      })}
                                    </div>
                                  </div>
                                </Grid>
                              )}

                              {/* Events Selection */}
                              <Grid item xs={12}>
                                <p style={{ fontSize: "1.17em", fontWeight: "bold", margin: 0 }}>
                                  {translations[selectedLanguage].selectEvents}

                                  {selectedEvents.length > 0 && (
                                    <span style={{ color: "#1976d2", marginLeft: "8px" }}>
                                      ({selectedEvents.length} {translations[selectedLanguage].eventsSelected})
                                    </span>
                                  )}
                                </p>
                                {selectedEvents.length === 0 && (
                                  <Typography variant="body2" color="textSecondary" style={{ marginBottom: "16px" }}>
                                    {translations[selectedLanguage].noEventsSelected}
                                  </Typography>
                                )}
                                <br />
                                <Grid container spacing={2} justifyContent="center">
                                  {filteredEvents.map((event) => {
                                    const isSelected = selectedEvents.some(selected => selected.code === event.code);
                                    return (
                                      <Grid
                                        item
                                        key={event.code}
                                        xs={6}
                                        sm={4}
                                        md={3}
                                        className={classes.eventItem}
                                      >
                                        <img
                                          src={event.imageUrl}
                                          alt={event.label}
                                          className={`${classes.eventImage} ${isSelected ? classes.selectedEvent : ''}`}
                                          onClick={() => handleEventToggle(event.code, event.eventName)}
                                        />
                                        {isSelected && (
                                          <div className={classes.eventCounter}>
                                            {selectedEvents.findIndex(selected => selected.code === event.code) + 1}
                                          </div>
                                        )}
                                        <Typography
                                          variant="body2"
                                          align="center"
                                          style={{
                                            marginTop: "2px",
                                            fontWeight: "600",
                                          }}
                                        >
                                          {event.eventDate && formatDateToDDMMM(event.eventDate)}
                                        </Typography>
                                      </Grid>
                                    );
                                  })}
                                </Grid>
                              </Grid>
                            </>
                          )}
                        </Grid>
                      </CardContent>
                      <Button
                        ref={submitButtonRef}
                        disabled={loading || (selectedEvents.length === 0 && !QRData?.referralCode)}
                        variant="contained"
                        color="primary"
                        type="submit"
                        className={classes.button}
                        style={{
                          padding: "10px 30px",
                          fontSize: "18px",
                          fontWeight: "bold",
                          borderRadius: "30px",
                          background:
                            loading || (selectedEvents.length === 0 && !QRData?.referralCode)
                              ? "linear-gradient(135deg, #bbb, #ddd)"
                              : "linear-gradient(135deg, #cc5200, #b065a1)",
                          color: "white",
                          textTransform: "uppercase",
                          boxShadow:
                            loading || (selectedEvents.length === 0 && !QRData?.referralCode)
                              ? "none"
                              : "0 4px 10px rgba(255, 127, 50, 0.3)",
                          transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                          if (!loading && (selectedEvents.length > 0 || QRData?.referralCode)) {
                            e.target.style.transform = "scale(1.05)";
                            e.target.style.boxShadow = "0 6px 15px rgba(255, 127, 50, 0.5)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!loading && (selectedEvents.length > 0 || QRData?.referralCode)) {
                            e.target.style.transform = "scale(1)";
                            e.target.style.boxShadow = "0 4px 10px rgba(255, 127, 50, 0.3)";
                          }
                        }}
                      >
                        {loading ? (
                          <CircularProgress size={24} style={{ color: "white" }} />
                        ) : (
                          // `${translations[selectedLanguage].register} (${selectedEvents.length})`
                          `${translations[selectedLanguage].register} ${!QRData?.referralCode ? `(${selectedEvents.length})` : ""
                          }`

                        )}
                      </Button>
                    </Form>
                  )}
                </Formik>
              </Card>
            </Grid>
          </div>
        ) : (
          <p
            style={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#FF5733",
              textAlign: "center",
              lineHeight: "1.4",
              padding: "12px 16px",
              wordWrap: "break-word",
            }}
          >
            {apiError ||
              "Registration is already completed or link has been used. Visit the event with your invite smart card."}
          </p>
        )}
      </Grid>

      {/* Rest of your modal components */}
      <VipMessageModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        modalCloseRef={modalCloseRef}
        message={openModal}
      />
      <MobileNumberAlert
        open={isModalOpen}
        onClose={handleModalClose}
        openClaim={openClaim}
        setOpenClaim={setOpenClaim}
        setResponse={setResponse}
      />
      <LimitMsgModal
        open={limitModalMsgOpen}
        onClose={handleModalClose}
        openClaim={openClaim}
        setOpenClaim={setOpenClaim}
        setResponse={setResponse}
      />
      {/* {console.log(response)} */}
      {response && QRData?.referralCode && (
        <VipInvitation
          event={response}
          selectedEvent={selectedEvents.length > 0 ? selectedEvents[0].code : id}
          download={translations[selectedLanguage].download}
          view={translations[selectedLanguage].view}
          modalCloseRef={modalCloseRef}
          isReferralCode={QRData?.referralCode ? true : false} // ✅ Pass referral flag
        />
      )}

      <div
        style={{
          background: "linear-gradient(to right, #2A5D87, #004AAD, #002A52)",
          padding: "10px 15px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          color: "white",
          fontSize: "14px",
          fontFamily: "'Arial', sans-serif",
        }}
      >
        <a
          href="https://www.bharat-online.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <span style={{ display: "flex", alignItems: "center" }}>
            Developed and Maintained By
            <img
              src="/bharatOnline.png"
              alt="bharatOnline"
              crossOrigin="anonymous"
              style={{
                marginLeft: "6px",
                marginRight: "6px",
                height: "25px",
              }}
            />
            <span style={{ fontWeight: "bold" }}>Bharat Online</span>
          </span>
        </a>
      </div>

      <Dialog open={limitMsgOpen} onClose={handleLimitClose}>
        <DialogTitle>{errorMsg}</DialogTitle>
        <DialogActions>
          <Button onClick={handleLimitClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default VipReg;